// @flow
import React, { Component } from 'react';
import ExperienceToast from 'app/common/react/components/experiences/ExperienceToast/ExperienceToast';
import withShowToast from 'app/common/lib/react/withShowToast';

type Props = {
  completionOnDismissal?: boolean,
  hideAllToasts: Function,
  showToast: (Toast: Object) => void,
  placementId: number,
};

const TOAST_DELAY = 2000;

class ExperienceToastLaunchWrapper extends Component<Props> {
  static defaultProps = {
    completionOnDismissal: false,
  };

  componentDidMount = () => {
    this.experienceToastsTimeout = window.setTimeout(
      () => this.triggerEducationToasts(),
      TOAST_DELAY,
    );
  };

  componentWillUnmount() {
    window.clearTimeout(this.experienceToastsTimeout);
  }

  experienceToastsTimeout: Function;

  triggerEducationToasts() {
    const { showToast, hideAllToasts, completionOnDismissal, placementId } = this.props;
    hideAllToasts();
    showToast(({ onHide }) => (
      <ExperienceToast
        completionOnDismissal={completionOnDismissal}
        onHide={onHide}
        placementId={placementId}
        shouldLogClicks={false}
      />
    ));
  }

  render() {
    return null;
  }
}

export default withShowToast(ExperienceToastLaunchWrapper);
